import React from "react";
import useCountdown from "../../../hooks/newyear/useCountdown";

const CountdownTimer = ({ deadline, onExpire, label = "남은 시간" }) => {
  const { display, isExpired, hours, minutes, seconds } = useCountdown(deadline, {
    onExpire,
  });

  if (isExpired) {
    return (
      <div className="newyear-countdown newyear-countdown--expired">
        <span className="newyear-countdown__label">{label}</span>
        <span className="newyear-countdown__time">종료</span>
      </div>
    );
  }

  return (
    <div className="newyear-countdown">
      <span className="newyear-countdown__label">{label}</span>
      <div className="newyear-countdown__timer">
        <span className="newyear-countdown__unit">
          <span className="newyear-countdown__value">{String(hours).padStart(2, "0")}</span>
          <span className="newyear-countdown__unit-label">시</span>
        </span>
        <span className="newyear-countdown__separator">:</span>
        <span className="newyear-countdown__unit">
          <span className="newyear-countdown__value">{String(minutes).padStart(2, "0")}</span>
          <span className="newyear-countdown__unit-label">분</span>
        </span>
        <span className="newyear-countdown__separator">:</span>
        <span className="newyear-countdown__unit">
          <span className="newyear-countdown__value">{String(seconds).padStart(2, "0")}</span>
          <span className="newyear-countdown__unit-label">초</span>
        </span>
      </div>
    </div>
  );
};

export default CountdownTimer;
